import { PoiOption } from 'components/common/types/Planner.types';
import { IncludedExcludedCounter } from 'components/common/types/IncludedExcludedCounter.types';
import POIOptionRow from '../POIOptionRow';
import { CUSTOM_POI_DATA_PROVIDER } from '../consts';

interface CustomPOICategoryListProps {
  customPoiCategories: PoiOption[];
  isItemSelected: (option: PoiOption) => boolean;
  getSelectedPOIIncludeAndRadius: (option: PoiOption) => { include?: boolean; radius?: number };
  getSelectedPOIIncludedExcludedChildrenCounter: (option: PoiOption) => IncludedExcludedCounter;
  navigateForward: (title: string, categoryPath?: string) => void;
  onChangeRadius: (radiusValue: number, option: PoiOption, optionIndex: number) => void;
  onIncludeExcludeChange: (option: PoiOption, optionIndex: number, selectedProvider: string) => void;
  resetCurrentFocusedItemIndex: () => void;
  onDeleteCustomCategory: (option: PoiOption) => void;
}

const CustomPOICategoryList: React.FC<CustomPOICategoryListProps> = ({
  customPoiCategories,
  isItemSelected,
  getSelectedPOIIncludeAndRadius,
  getSelectedPOIIncludedExcludedChildrenCounter,
  navigateForward,
  onChangeRadius,
  onIncludeExcludeChange,
  resetCurrentFocusedItemIndex,
  onDeleteCustomCategory,
}) => (
  <>
    {customPoiCategories.map((category, index) => {
      const isSelected = isItemSelected(category);
      const { include, radius } = getSelectedPOIIncludeAndRadius(category);
      const { included, excluded } = getSelectedPOIIncludedExcludedChildrenCounter(category);

      return (
        <POIOptionRow
          key={category.name}
          currentFocusedIndex={null}
          index={index}
          option={category}
          isMainLevel
          navigateForward={navigateForward}
          onChangeRadius={(radiusValue) => onChangeRadius(radiusValue, category, index)}
          onIncludeExcludeChange={(item) => onIncludeExcludeChange(item, index, CUSTOM_POI_DATA_PROVIDER)}
          isSelected={isSelected || !!include}
          isIncluded={include}
          radius={radius}
          resetCurrentFocusedItemIndex={resetCurrentFocusedItemIndex}
          includedChildrenNumber={included}
          excludedChildrenNumber={excluded}
          isCustomPOI
          onDeleteCustomCategory={() => onDeleteCustomCategory(category)}
          isDeselectAllowed={false}
        />
      );
    })}
  </>
);

export default CustomPOICategoryList;
